export const filterNullElements = (treatments) =>
  Object.fromEntries(Object.entries(treatments).filter(([_, value]) => value !== null));

const getSelectionGroups = (selectionGroups) =>
  Object.fromEntries(
    Object.entries(selectionGroups).map(([groupName, groupContent]) => [
      groupName,
      {
        ...groupContent,
        treatments: filterNullElements(groupContent.treatments),
      },
    ])
  );

export const spaDayAdapter = (basketData) => ({
  ...basketData,
  ...(basketData.selectionGroups
    ? { selectionGroups: getSelectionGroups(basketData.selectionGroups) }
    : {}),
});

export const filterExtrasIdsByGuest = (extras, guest) => {
  const filteredExtrasByGuest = Object.entries(extras).reduce((filteredExtras, [key, values]) => {
    const isGuestExtras = values.find(({ value }) =>
      value.externalSpaId
        ? value.externalSpaId === guest.externalSpaId
        : value.value === guest.value
    );

    return {
      ...filteredExtras,
      ...(isGuestExtras && { [key]: values }),
    };
  }, {});

  return filteredExtrasByGuest
    ? Object.keys(filteredExtrasByGuest).map((treatmentKey) => ({
        id: parseInt(treatmentKey.split('-')[1], 10),
      }))
    : null;
};
